import React from 'react'
import Table from '../../components/common/Table'
import { SiteSurveyResponseDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface SiteSurveyResponseTableProps {
    data: SiteSurveyResponseDTO[];
    handleEdit: (row: SiteSurveyResponseDTO) => void;
    handleDelete: (row: SiteSurveyResponseDTO) => void;
    currentPage: number;
    totalPages: number;
    setCurrentPage: (page: number) => void;
    pageSize: number;
    setPageSize: (size: number) => void;
    isLoading: boolean;
}

const SiteSurveyResponseTable: React.FC<SiteSurveyResponseTableProps> = ({
    data,
    handleEdit,
    handleDelete,
    currentPage,
    totalPages,
    setCurrentPage,
    pageSize,
    setPageSize,
    isLoading,
}) => {
    return (
        <Table
            columns={[

                {
                    label: "Phone",
                    key: "phone",
                    priority: 1,
                },

                {
                    label: "Uses Earthranger",
                    key: "usesEarthranger",
                    priority: 5,
                },

                {
                    label: "Er Survives Outage",
                    key: "erSurvivesOutage",
                    priority: 6,
                },
                {
                    label: "Drone Ownership",
                    key: "droneOwnership",
                    priority: 6,
                },

                {
                    label: "Drone Model Dji",
                    key: "droneModelDji",
                    priority: 8,
                },

                {
                    label: "Drone Model Other",
                    key: "droneModelOther",
                    priority: 8,
                },

                {
                    label: "Launch Method",
                    key: "launchMethod",
                    priority: 7,
                },



                {
                    label: "First Site Interest",
                    key: "firstSiteInterest",
                    priority: 7,
                },

                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                    priority: 2,
                },

            ]}
            data={data}
            actions={{
                onEdit: handleEdit,
                onDelete: handleDelete,
            }}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            isLoading={isLoading}
        />
    );
};

export default SiteSurveyResponseTable;
